"use client";

import { useEffect } from "react";
import { isChunkError, recoverOnce } from "@/lib/chunkRecovery";
import { corners } from "@/lib/tokens/semantic";

export default function GlobalError({
  error,
}: {
  error: Error & { digest?: string };
}) {
  useEffect(() => {
    if (isChunkError(error)) void recoverOnce();
  }, [error]);

  return (
    <html lang="ru">
      <body style={{
        minHeight: "100dvh", background: "var(--cg-bg-elevated)", color: "var(--cg-text-primary)",
        padding: 24, fontFamily: "monospace", fontSize: 13,
        wordBreak: "break-all", whiteSpace: "pre-wrap", margin: 0,
      }}>
        <h2 style={{ color: "var(--cg-accent-danger)", margin: "0 0 16px" }}>Global Error</h2>
        <p><b>Message:</b> {error.message}</p>
        <p><b>Name:</b> {error.name}</p>
        {error.digest && <p><b>Digest:</b> {error.digest}</p>}
        <pre style={{
          background: "var(--cg-bg-sunken)", padding: 12, borderRadius: corners.input,
          overflow: "auto", fontSize: 11, marginTop: 12,
        }}>{error.stack}</pre>
      </body>
    </html>
  );
}
